import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { ApplyPipe } from '@interacta-shared/ui';
import { IconComponent } from '@interacta-shared/ui-icons';
import {
    getGenericEmptyUserPlaceholderAsMember,
    isMemberUser,
    Member,
} from '@interacta-shared/util-member';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';

import { MemberComponent } from '@interacta-shared/feature-member';
import { ActivityDateContainerComponent } from '@modules/shared-v2/components/activity-date-container/activity-date-container.component';
import { TranslateService } from '@ngx-translate/core';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-activity-edit-notification',
    templateUrl: './activity-edit-notification.component.html',
    imports: [
        UserNotificationComponent,
        MemberComponent,
        IconComponent,
        ActivityDateContainerComponent,
        ApplyPipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityEditNotificationComponent {
    private readonly translateService = inject(TranslateService);

    notification = input.required<UserNotificationEvent>();

    readonly emptyMemberPlaceholder = getGenericEmptyUserPlaceholderAsMember(
        this.translateService.instant('DASHBOARD.FILTERS.NOT_ASSIGNED'),
    );

    /**
     * set deleted property to true to see name in strike-through style
     */
    markAsDeleted(oldValueMember: Member): Member {
        if (isMemberUser(oldValueMember)) {
            return {
                ...oldValueMember,
                user: { ...oldValueMember.user, deleted: true },
            };
        } else {
            return {
                ...oldValueMember,
                group: {
                    ...oldValueMember.group,
                    deleted: true,
                },
            };
        }
    }
}
